import React, { useEffect, lazy, Suspense } from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import { Helmet } from "react-helmet";

import NotFoundPage from "../pages/NotFoundPage";
import MyTeamOverallChat from "../pages/Assessment/MyCoach/MyChatBot/MyTeamOverallChat";

const MainPage = lazy(() => import("../pages/Surveylink/MainPage"));
const TeenCareerPage = lazy(() => import("../pages/Surveylink/TeenCareerPage"));
const Login = lazy(() => import("../pages/Login/Login"));
const Ssologin = lazy(() => import("../pages/Ssologin/Ssologin"));
const AssessmentLogin = lazy(() => import("../pages/Login/AssessmentLogin"));
const AssessmentPage = lazy(() => import("../pages/Surveylink/AssessmentPage"));
const Registration = lazy(() => import("../pages/Assessment/Registration/Registration"));
const SignIn = lazy(() => import("../pages/Assessment/Login/SignIn"));
const Package = lazy(() => import("../pages/Assessment/Package/Package"));
const Orders = lazy(() => import("../pages/Assessment/Orders/Orders"));
const SurveyLogin = lazy(() => import("../pages/Assessment/Survey/SurveyLogin"));
const CoachLogin = lazy(() => import("../pages/Assessment/MyCoach/CoachLogin"));
const MyCoachTeams = lazy(() => import("../pages/Assessment/MyCoach/MyCoachTeams"));
const MyCoachTeamAvira = lazy(() => import("../pages/Assessment/MyCoach/MyChatBot/MyTeamList"));
const MyCoachTeamAviraBot = lazy(() => import("../pages/Assessment/MyCoach/MyChatBot/MyTeamChatBot"));


const AssessmentLoginByOTP = lazy(() => import("../pages/Login/AssessmentLoginByOTP"));
const Home = lazy(() => import("../pages/Assessment/Home/Home"));
const Homeold = lazy(() => import("../pages/Assessment/Home/Homeold"));
const TeenTalent = lazy(() => import("../pages/Assessment/TeenTalent/TeenTalent"));
const TeenDiscoverYourself = lazy(() => import("../pages/Assessment/TeenDiscoverYourself/TeenDiscoverYourself"));
const TeenCareerLibraries = lazy(() => import("../pages/Assessment/TeenCareerLibraries/TeenCareerLibraries"));
const TeenPersonalizedReport = lazy(() => import("../pages/Assessment/TeenPersonalizedReport/TeenPersonalizedReport"));
const TeenCareerFitment = lazy(() => import("../pages/Assessment/TeenCareerFitment/TeenCareerFitment"));
const Employer = lazy(() => import("../pages/Assessment/Home/Employer"));
const Individual = lazy(() => import("../pages/Assessment/Home/Individual"));
const ProductDetails = lazy(() => import("../pages/Assessment/ProductDetails/ProductDetails"));
const Mycart = lazy(() => import("../pages/Assessment/MyCart/Mycart"));
const MyOrders = lazy(() => import("../pages/Assessment/MyOrders/MyOrders.js"));
const OrderReview = lazy(() => import("../pages/Assessment/Orders/OrderReview"));
const Payment = lazy(() => import("../pages/Assessment/Payment/Payment"));
const DomainTheme = lazy(() => import("../pages/Assessment/DomainTheme/DomainTheme"));
const ContactUs = lazy(() => import("../pages/Assessment/ContactUs/ContactUs"));
const StrengthWorks = lazy(() => import("../pages/Assessment/StrengthWorks/StrengthWorks"));
const EditProfile = lazy(() => import("../pages/Assessment/MyOrders/EditProfile"));
const User = lazy(() => import("../pages/Assessment/MyOrders/User"));
const AssessmentProducts = lazy(() => import("../pages/Assessment/MyOrders/AssessmentProducts"));
const SearchUsers = lazy(() => import("../pages/Assessment/MyOrders/SearchUsers"));
const AssessmentProductsNew = lazy(() => import("../pages/Assessment/MyOrders/AssessmentProductsNew"));
const Term = lazy(() => import("../pages/Assessment/Term/Term"));
const ExpertBooked = lazy(() => import("../pages/Surveylink/QuestionV6/Summary/Summary/ExpertsSummary/ExpertBooked"));
const Privacy = lazy(() => import("../pages/Assessment/PrivacyandPolicy/Privacy"));
const Emailer = lazy(() => import("../pages/Assessment/Emailer/Emailer"));
const Cancelled = lazy(() => import("../pages/Assessment/Payment/Cancelled"));
const ImpactCoach = lazy(() => import("../pages/Assessment/ImpactCoach/ImpactCoach"));
const Test = lazy(() => import("../pages/Test"));
const Temp = lazy(() => import("../pages/Assessment/ProductDetails/Temp"));
const Blog = lazy(() => import("../pages/Assessment/Blog/Blog"));
const BlogDeatil = lazy(() => import("../pages/Assessment/Blog/BlogDeatails"));
const Aboutus = lazy(() => import("../pages/Assessment/Aboutus/Aboutus"));
const Avira = lazy(() => import("../pages/Assessment/Avira/Avira"));
const MyTeams = lazy(() => import("../pages/Assessment/MyOrders/MyTeams"));
const MyCoaches = lazy(() => import("../pages/Assessment/MyOrders/MyCoaches"));

// const ResearchPaper = lazy(() => import("../pages/Assessment/ResearchPaper/ResearchPaper"));
const ExploreResearch = lazy(() => import("../pages/Assessment/ExploreResearch/ExploreResearch"));
const ResearchInsights = lazy(() => import("../pages/Assessment/ResearchInsights/ResearchInsights"));
const MyChatBot = lazy(() => import("../pages/UserDashboard/MyChatBot/MyChatBot"));
const HiringAvira = lazy(() => import("../pages/Assessment/MyOrders/HiringAvira"));
const TalentCoach = lazy(() => import("../pages/Assessment/TalentCoach/TalentCoach"));

const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen bg-slate-50">
    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#2196f3]"></div>
  </div>
);

export default function App() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const TalentPlusSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://www.talentplus.com/",
    name: "Consultant in Mumbai, Maharashtra",
    image: "https://www.talentplus.com/svg/talentplus-logo.svg",
    url: "https://www.talentplus.com/",
    review: {
      "@type": "Review",
    },
    reviewRating: {
      "@type": "Rating",
      ratingValue: "4.9",
      bestRating: "5",
    },
    address: {
      "@type": "PostalAddress",
      streetAddress: "1&2, GREEN HILL-B, 303, 25/A, near NNP, Goregaon ",
      addressLocality: "Mumbai,",
      addressRegion: "Maharashtra",
      postalCode: "400065 ,",
      addressCountry: "IN",
    },
    offers: {
      "@type": "Offer",
      price: "20-25",
      priceCurrency: "USD",
      availability: "https://schema.org/InStock",
    },
    author: {
      "@type": "Person",
      name: "talentplus",
    },
  };

  return (
    <div className="font-fma">
      <Helmet>
        <script type="application/ld+json" defer>
          {JSON.stringify(TalentPlusSchema)}
        </script>
      </Helmet>

      <HashRouter>
        <Suspense fallback={<PageLoader />}>
          <Switch>

            <Route exact path="/" render={() => <Redirect to="/assessment/home" />} />

            <Route path="/assessment/home" component={withRouter(Home)} />
            <Route path="/assessment/employer" component={withRouter(Employer)} />
            <Route path="/assessment/individual" component={withRouter(Individual)} />
            <Route path="/v2/:id" component={withRouter(MainPage)} />
            <Route path="/login/:id" component={withRouter(Login)} />

            <Route path="/ssologin" component={withRouter(Ssologin)} />
            <Route path="/notfound" component={withRouter(NotFoundPage)} />
            <Route path="/assessment/login" component={withRouter(AssessmentLogin)} />
            <Route path="/assessment/signin" component={withRouter(AssessmentLoginByOTP)} />
            <Route path="/assessment/survey" component={withRouter(AssessmentPage)} />
            <Route path="/assessment/career" component={withRouter(TeenCareerPage)} />
            <Route path="/assessment/teen-talent" component={withRouter(TeenTalent)} />
            <Route path="/assessment/teen-discover-yourself" component={withRouter(TeenDiscoverYourself)} />
            <Route path="/assessment/teen-career-libraries" component={withRouter(TeenCareerLibraries)} />
            <Route path="/assessment/teen-personalized-report" component={withRouter(TeenPersonalizedReport)} />
            <Route path="/assessment/teen-career-fitment-analysis" component={withRouter(TeenCareerFitment)} />
            <Route path="/assessment/homeold" component={withRouter(Homeold)} />
            <Route path="/assessment/impact-coach" component={withRouter(ImpactCoach)} />
            <Route path="/assessment/sign-up" component={withRouter(Registration)} />
            <Route path="/assessment/sign-in" component={withRouter(SignIn)} />
            <Route path="/assessment/products" component={withRouter(Package)} />
            <Route path="/assessment/terms-and-conditions" component={withRouter(Term)} />
            <Route path="/assessment/privacy-policy" component={withRouter(Privacy)} />
            <Route path="/assessment/orders" component={withRouter(Orders)} />
            <Route path="/assessment/surveylogin" component={withRouter(SurveyLogin)} />
            <Route path="/assessment/coachlogin" component={withRouter(CoachLogin)} />
            <Route path="/assessment/coachteams" component={withRouter(MyCoachTeams)} />
            <Route path="/assessment/coachavira/:id" component={withRouter(MyCoachTeamAvira)} />
            <Route path="/assessment/coachavirabot/:id/:idc" component={withRouter(MyCoachTeamAviraBot)} />
            <Route path="/assessment/coachteamavira/:id" component={withRouter(MyTeamOverallChat)} />


            <Route path="/assessment/my-cart" component={withRouter(Mycart)} />
            <Route path="/assessment/my-orders" component={withRouter(MyOrders)} />
            <Route path="/assessment/productdetails/:id1/:id2" component={withRouter(ProductDetails)} />
            <Route path="/assessment/temp" component={withRouter(Temp)} />
            <Route path="/assessment/order-review/:id" component={withRouter(OrderReview)} />
            <Route path="/assessment/the-4-domains-and-22-themes" component={withRouter(DomainTheme)} />
            <Route path="/assessment/contact-us" component={withRouter(ContactUs)} />
            <Route path="/assessment/order-complete/:id" component={withRouter(Payment)} />
            <Route path="/assessment/order-cancelled" component={withRouter(Cancelled)} />
            <Route path="/assessment/how-talentplus-strength-works" component={withRouter(StrengthWorks)} />
            <Route path="/assessment/profile-summary" component={withRouter(EditProfile)} />
            <Route path="/assessment/user" component={withRouter(User)} />
            <Route path="/assessment/assessment-code" component={withRouter(AssessmentProducts)} />
            <Route path="/assessment/searchusers" component={withRouter(SearchUsers)} />
            <Route path="/assessment/myteam" component={withRouter(MyTeams)} />
            <Route path="/assessment/mycoaches" component={withRouter(MyCoaches)} />

            <Route path="/assessment/assessment-code-new" component={withRouter(AssessmentProductsNew)} />
            <Route path="/assessment/emailer" component={withRouter(Emailer)} />
            <Route path="/assessment/test" component={withRouter(Test)} />
            <Route path="/assessment/expert-booked/:id" component={withRouter(ExpertBooked)} />
            <Route path="/assessment/blog" component={withRouter(Blog)} />
            <Route path="/assessment/blogdetails/:id" component={withRouter(BlogDeatil)} />
            <Route path="/assessment/about-us" component={withRouter(Aboutus)} />
            <Route path="/assessment/avira-ai" component={withRouter(Avira)} />
            <Route path="/assessment/research-insights" component={withRouter(ExploreResearch)} />
            <Route path="/assessment/talentweave" component={withRouter(ResearchInsights)} />
            <Route path="/assessment/mychatbot" component={withRouter(MyChatBot)} />
            <Route path="/assessment/HiringAvira/:id" component={withRouter(HiringAvira)} />
            <Route path="/assessment/certified-impact-coach" component={withRouter(TalentCoach)} />

          </Switch>
        </Suspense>
      </HashRouter>
    </div>
  );
}